'use strict';

const enableNotifications = (state, enable) => {
  state.enableNotifications = enable;
};

const addIncomingNotificationSound = (state, notificationSound) => {
  state.incomingNotificationSounds.push(notificationSound)
}

const setIncomingNotificationSound = (state, notificationSound) => {
  state.selectedIncomingNotificationSound = notificationSound;
}

const updateSettings = (state, settings) => {
  state.settings.eula = settings.eula;
  state.settings.displayPreferences = { ...settings.displayPreferences };
  state.settings.additionalOptions = { ...settings.additionalOptions };
  state.settings.interfaceState = {
    currentTab: settings.interfaceState.currentTab,
    currentConversation: settings.interfaceState.currentConversation,
    contactsExpansionStates: { ...settings.interfaceState.contactsExpansionStates },
    favoriteContacts: settings.interfaceState.favoriteContacts
  };
};

const addContactToFavorites = (state, contact) => {
  if (state.settings.interfaceState.favoriteContacts === undefined) {
    state.settings.interfaceState.favoriteContacts = [];
  }
  state.settings.interfaceState.favoriteContacts.push(contact.number);
};

const removeContactFromFavorites = (state, contact) => {
  state.settings.interfaceState.favoriteContacts = state.settings.interfaceState.favoriteContacts.filter(number => (number !== contact.number));
};

export default {
  addIncomingNotificationSound,
  enableNotifications,
  setIncomingNotificationSound,
  updateSettings,
  addContactToFavorites,
  removeContactFromFavorites
};
